import React, { FC, useEffect, useState } from 'react';
import { MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import VendorApi from 'src/api/VendorApi';
import useOnMount from 'src/hooks/useOnMount';
import TextLabel from '../TextLabel';

declare interface CategoryMultiSelectProps {
  onChange: (event: MultiSelectChangeEvent) => void;
  initialValue: string[];
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const CategoryMultiSelect: FC<CategoryMultiSelectProps> = ({ onChange, initialValue, style }) => {
  const [value, setValue] = useState<string[]>([]);
  const [allCategories, setAllCategories] = useState<string[]>([]);

  type SelectState = { data: string[] };
  const [selectState, setSelectState] = useState<SelectState>({ data: [] });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useOnMount(() => {
    setIsLoading(true);
    VendorApi.getAllItemCategoryNames().then((data: string[]) => {
      setAllCategories(data);

      setSelectState({
        data: data,
      });

      setIsLoading(false);
    });
  });

  useEffect(() => {
    if (!(initialValue.length === 1 && initialValue[0] === '')) {
      setValue([...initialValue]);
    }
  }, [initialValue]);

  const filterChange = (event: MultiSelectFilterChangeEvent) => {
    setSelectState({
      data: filterBy([...allCategories], event.filter),
    });
  };

  const handleChange = (event: MultiSelectChangeEvent) => {
    setValue(event.value);
    onChange(event);
  };

  return (
    <>
      <TextLabel>Categories</TextLabel>
      <MultiSelect data={selectState.data} loading={isLoading} value={value} filterable={true} onChange={handleChange} onFilterChange={filterChange} style={style} />
    </>
  );
};

export default CategoryMultiSelect;
